import React from 'react';
import CorporateTours from '../../../assets/Service-icon/Corporate Tours.svg';
import DestinationWeddings from '../../../assets/Service-icon/Destination Weddings.svg';
import ConferenceManagement from '../../../assets/Service-icon/Conference Management Services.svg';
import EventPlanning from '../../../assets/Service-icon/Event Planning.svg';
import Exhibitions from '../../../assets/Service-icon/Exhibitions.svg';
import GlobalHotel from '../../../assets/Service-icon/Global Hotel.svg';

const Benefits = () => {
  const options = [
    {
      id: 1,
      img: CorporateTours,
      title: 'Corporate Tours',
    },
    {
      id: 2,
      img: DestinationWeddings,
      title: 'Destination Weddings',
    },
    {
      id: 3,
      img: ConferenceManagement,
      title: 'Conference Management Services',
    },
    {
      id: 4,
      img: EventPlanning,
      title: 'Event Planning & Themes',
    },
    {
      id: 5,
      img: Exhibitions,
      title: 'Exhibitions & Expos',
    },
    {
      id: 6,
      img: GlobalHotel,
      title: 'Global Hotel Program',
    },
  ];

  return (
    <div className='mb-10 px-4 py-10 text-center'>
      {/* Grid */}
      <div className='mx-auto grid max-w-7xl gap-8 md:grid-cols-4'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.title}
              className='mb-4 h-24 w-24 object-contain'
            />
            <h3 className='text-dark mb-2 text-xl font-semibold md:text-2xl'>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
